import { Component } from '@angular/core';

const BASE_EL = '.spotlight';

@Component({
  selector: 'app-background-images',
  templateUrl: './background-images.component.html',
  styleUrls: ['./background-images.component.scss'],
})
export class BackgroundImagesComponent {
  // canvas: HTMLCanvasElement;
  // renderer: THREE.WebGLRenderer;
  // scene: THREE.Scene;
  // camera: THREE.OrthographicCamera;
  // textures: THREE.Texture[];
  // material: THREE.ShaderMaterial;
  // plane: THREE.Mesh;
  // private imagesPaths;
  // private activeShowcaseTextureIndex: number;
  // private blend = { value: 0 };
  // constructor(
  //   private ngZone: NgZone,
  //   private globalUtilsService: GlobalUtilsService
  // ) {
  //   this.textures = [];
  //   this.activeShowcaseTextureIndex = 0;
  // }
  // ngAfterViewInit() {
  //   this.imagesPaths = getImagesPathsByActiveScreen(this.globalUtilsService.activeScreen);
  //   this.ngZone.runOutsideAngular(
  //     this.setupBackgroundImagesComponent.bind(this)
  //   );
  // }
  // private setupBackgroundImagesComponent() {
  //   from(this.loadImages(...this.imagesPaths))
  //     .pipe(this.transformImageToTexture())
  //     .subscribe((textures: THREE.Texture[]) => {
  //       this.setupShowcaseTextures(textures);
  //       this.setupScene();
  //       this.setupResizeBehavior();
  //       this.initializeRenderOfScene();
  //       this.initializeImageChangeBehavior();
  //     });
  // }
  // private setupResizeBehavior() {
  //   this.resize();
  //   this.globalUtilsService.viewportChanged.subscribe(() => {
  //     this.resize();
  //   });
  // }
  // private initializeRenderOfScene() {
  //   requestAnimationFrame(this.render.bind(this));
  // }
  // private initializeImageChangeBehavior() {
  //   // https://stackoverflow.com/questions/5927284/how-can-i-make-setinterval-also-work-when-a-tab-is-inactive-in-chrome
  //   // https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
  //   let time = 0;
  //   setInterval(() => {
  //     // avoid jumps of images when tab is inactive
  //     if (document.hidden) {
  //       return;
  //     }
  //     if (time > 8000) {
  //       this.doAnimation();
  //       time = 0;
  //     } else {
  //       time += 100;
  //     }
  //   }, 100);
  // }
  // private doAnimation() {
  //   gsap.fromTo(
  //     this.blend,
  //     { value: 0 },
  //     {
  //       duration: 2.6,
  //       value: 1,
  //       ease: 'power4.out',
  //       onComplete: () => {
  //         this.blend.value = 0;
  //         this.incrementTextureActiveIndex();
  //       }
  //     }
  //   );
  // }
  // private setupShowcaseTextures(textures: THREE.Texture[]) {
  //   this.textures = textures;
  // }
  // private setupScene() {
  //   this.canvas = document.querySelector('#background-images');
  //   this.renderer = new THREE.WebGLRenderer({
  //     canvas: this.canvas,
  //     antialias: true
  //   });
  //   this.renderer.setSize(
  //     document.querySelector('.spotlight').clientWidth,
  //     document.querySelector('.spotlight').clientHeight
  //   );
  //   this.renderer.setClearColor(0xffffff, 0.0);
  //   this.renderer.setPixelRatio(window.devicePixelRatio);
  //   this.camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0.1, 20);
  //   this.scene = new THREE.Scene();
  //   const geometry = new THREE.PlaneGeometry(2.5, 2);
  //   const material = new THREE.ShaderMaterial({
  //     uniforms: {
  //       resolution: {
  //         type: 'v2',
  //         value: new THREE.Vector2(
  //           this.canvas.offsetWidth,
  //           this.canvas.offsetHeight
  //         )
  //       },
  //       imageResolution: {
  //         type: 'v2',
  //         value: this.getResolutionActiveTexture()
  //       },
  //       blend: {
  //         value: this.blend.value
  //       },
  //       actualTexture: {
  //         type: 't',
  //         value: this.getActiveTexture()
  //       },
  //       nextTexture: {
  //         type: 't',
  //         value: this.getNextTexture()
  //       }
  //     },
  //     vertexShader,
  //     fragmentShader
  //   });
  //   this.material = material;
  //   this.plane = new THREE.Mesh(geometry, material);
  //   this.plane.position.z = 0;
  //   this.scene.add(this.plane);
  // }
  // private getResolutionActiveTexture() {
  //   const activeTexture = this.getActiveTexture();
  //   return new THREE.Vector2(
  //     activeTexture.image.width,
  //     activeTexture.image.height
  //   );
  // }
  // private getActiveTexture() {
  //   return this.textures[this.activeShowcaseTextureIndex];
  // }
  // private getNextTexture() {
  //   const nextIndex =
  //     (this.activeShowcaseTextureIndex + 1) % this.textures.length;
  //   return this.textures[nextIndex];
  // }
  // private incrementTextureActiveIndex() {
  //   this.activeShowcaseTextureIndex =
  //     (this.activeShowcaseTextureIndex + 1) % this.textures.length;
  // }
  // private updateUniforms() {
  //   this.material.uniforms.resolution.value = new THREE.Vector2(
  //     this.canvas.offsetWidth,
  //     this.canvas.offsetHeight
  //   );
  //   this.material.uniforms.actualTexture.value = this.getActiveTexture();
  //   this.material.uniforms.nextTexture.value = this.getNextTexture();
  //   this.material.uniforms.blend.value = this.blend.value;
  // }
  // private resize() {
  //   setTimeout(() => {
  //     this.renderer.setSize(
  //       document.querySelector('.spotlight').clientWidth,
  //       document.querySelector('.spotlight').clientHeight
  //     );
  //     this.updateUniforms();
  //     this.camera.updateProjectionMatrix();
  //   }, 0);
  // }
  // private render(time: number) {
  //   this.updateUniforms();
  //   this.renderer.render(this.scene, this.camera);
  //   requestAnimationFrame(this.render.bind(this));
  // }
  // private loadImages(...srcs: string[]) {
  //   return new Promise(resolve => {
  //     const images = [];
  //     let count = 0;
  //     for (const src of srcs) {
  //       const image = new Image();
  //       image.onload = () => {
  //         count++;
  //         if (images.length === count) {
  //           resolve(images);
  //         }
  //       };
  //       image.src = src;
  //       images.push(image);
  //     }
  //   });
  // }
  // private transformImageToTexture() {
  //   return map((images: HTMLImageElement[]): THREE.Texture[] => {
  //     const textures = [];
  //     images.forEach(image => {
  //       const tex = new THREE.Texture(image);
  //       tex.needsUpdate = true;
  //       tex.magFilter = THREE.NearestFilter;
  //       tex.minFilter = THREE.NearestFilter;
  //       textures.push(tex);
  //     });
  //     return textures;
  //   });
  // }
}
